export const ChartDataManual = {
    type: 'horizontalBar',
    data: {
	labels: ['Trinity', 'Leading Brand A', 'Leading Brand B'],
	datasets: [
	    { 
		label: 'Manual time needed (minutes)',
		data: [22, 816, 831],
		backgroundColor: [
		    'rgba(192,192,192,.75)',
		    'rgba(192,192,192,.75)',
		    'rgba(192,192,192,.75)',
		],
		borderColor: 'rgba(255,0,0)',
		borderWidth: 1,
	    }
	]
    },
    options: {
	responsive: true,
	lineTension: 1,
	scales: {
	    yAxes: [{
		ticks: {
		    beginAtZero: true,
		    padding: 25,
		}
	    }]
	}
    }
}

export default ChartDataManual;
